import { EventEmitter } from "events";

class ThemeStore extends EventEmitter {
  private static instance: ThemeStore;
  private isDarkMode: boolean = false;

  private constructor() {
    super();
    this.loadThemeFromStorage();
  }

  public static getInstance(): ThemeStore {
    if (!ThemeStore.instance) {
      ThemeStore.instance = new ThemeStore();
    }
    return ThemeStore.instance;
  }

  private loadThemeFromStorage(): void {
    const savedTheme = localStorage.getItem("chirpstack-theme");
    if (savedTheme) {
      this.isDarkMode = savedTheme === "dark";
    } else {
      // Check system preference
      this.isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
    }
    this.applyTheme();
  }

  public toggleTheme(): void {
    this.isDarkMode = !this.isDarkMode;
    this.saveThemeToStorage();
    this.applyTheme();
    this.emit("change");
  }

  public setTheme(isDark: boolean): void {
    this.isDarkMode = isDark;
    this.saveThemeToStorage();
    this.applyTheme();
    this.emit("change");
  }

  public getIsDarkMode(): boolean {
    return this.isDarkMode;
  }

  private saveThemeToStorage(): void {
    localStorage.setItem("chirpstack-theme", this.isDarkMode ? "dark" : "light");
  }

  private applyTheme(): void {
    const root = document.documentElement;
    if (this.isDarkMode) {
      root.classList.add("dark-theme");
      root.classList.remove("light-theme");
    } else {
      root.classList.add("light-theme");
      root.classList.remove("dark-theme");
    }
  }
}

export default ThemeStore.getInstance();